import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import Handsontable from 'handsontable';
import {environment} from '../../environments/environment';
import {ReportDataService} from '../report-data.service';

@Component({
  selector: 'app-worksheet',
  templateUrl: './worksheet.component.html',
  styleUrls: ['./worksheet.component.css']
})

/**
 * Wrapper for the main "Worksheet View" tab.  Renders buttons and controls navigation to each individual worksheet 
 * in the project via. Angular router. We also notify the file data service of currently selected worksheet so that other 
 * components can interrogate UI state to control things like template download and Excel parsing
 */
export class WorksheetComponent implements OnInit {

  environment: any;
  templateURL: string;

  constructor(private router: Router, private reportService: ReportDataService) { }

  ngOnInit() {
    this.environment = environment;
    this.router.navigate([ {outlets: { editableTables: [this.environment.CONFIGURATION] }}]);
    this.reportService.setSelectedWorksheet(this.environment.CONFIGURATION);
    this.reportService.getTemplate().subscribe(value => this.templateURL = value);
  }

  updateHeaders() {
  }

  changeTab(target: String) {
      this.reportService.setSelectedWorksheet(target);
      this.router.navigate([ {outlets: { editableTables: [target] }}]);
  }

  importFromExcel(event) {
    this.reportService.importFromExcel(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/worksheet/worksheet.component.ts